let framemouldings = [
  {
    id: 'printonly',
    name: 'Print Only',
    category: 'Paper',
    description: `Our most popular fine art paper, 5/5 rated by conservatree.org and made with cotton fibre. The lightly defined felt structure and characteristic soft feel gives every print an incredible depth and three-dimensional appearance.`,
    type: 'Paper',
    material: 'Cotton',
    manufactured: 'Germany',
    examples: [
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675360050/Frame%20Profile%20Images/Print%20Only/photorag-310_teg3ar.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675360050/Frame%20Profile%20Images/Print%20Only/photorag-310_teg3ar.jpg',
        caption: 'Photorag 310gsm (matte)'
      }
    ],
    variations: [
      {
        option1: 'Photorag 310gsm',
        option2: 'Matte',
        sku: 'W307238',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675190448/Frame%20Patterns/mayfair-black_x5thok.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675360050/Frame%20Profile%20Images/Print%20Only/photorag-310_teg3ar.jpg',
        width: {
          in: 0,
          mm: 0
        },
        depth: {
          in: 0,
          mm: 0
        },
        rebateh: {
          in: 0,
          mm: 0
        },
        rebate: {
          in: 0,
          mm: 0
        },
        costm: 15,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
    ]
  },
  {
    id: 'hatton',
    name: 'Hatton',
    category: 'Luxury',
    description: `Square and linear shapes are very much in vogue. Our Hatton collection features three metallic colours champagne gold, bronze or pewter painted finishes with a painted trim along the edges. Available in two widths 20mm or 30mm.`,
    type: 'Wood',
    material: 'Pine',
    manufactured: 'Germany',
    examples: [
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1672581288/Examples/Hatton/hatton-front_ev0c6h.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672581288/Examples/Hatton/hatton-front_ev0c6h.jpg',
        caption: 'Champagne Gold'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1672581288/Examples/Hatton/hatton-corner_ppku7l.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672581288/Examples/Hatton/hatton-corner_ppku7l.jpg',
        caption: 'Champagne Gold'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1676386807/Examples/Hatton/hatton-front-black_pwq4mq.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1676386807/Examples/Hatton/hatton-front-black_pwq4mq.jpg',
        caption: 'Black'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1676386939/Examples/Hatton/hatton-black-corner_e1winv.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1676386939/Examples/Hatton/hatton-black-corner_e1winv.jpg',
        caption: 'Black'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1672597400/Examples/Hatton/hatton-photos_wynsjw.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672597400/Examples/Hatton/hatton-photos_wynsjw.jpg',
        caption: 'Silver'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1672597404/Examples/Hatton/hatton-medals_mauxhj.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672597404/Examples/Hatton/hatton-medals_mauxhj.jpg',
        caption: 'Champagne Gold'
      },
    ],
    variations: [
      {
        option1: '20mm(0.79in)',
        option2: 'Champagne Gold',
        sku: 'W9456551',
        pattern: 'https://app.printframeco.com/27006bce-b3a7-4ffc-bad6-de257c0be7b8/hattoncg.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672508902/Frame%20Profile%20Images/Hatton/hatton-20-cg_msooqr.jpg',
        width: {
          in: 0.79,
          mm: 20
        },
        depth: {
          in: 0.79,
          mm: 20
        },
        rebateh: {
          in: 0.39,
          mm: 10
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 65,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '30mm(1.18in)',
        option2: 'Champagne Gold',
        sku: 'W9457551',
        pattern: 'https://app.printframeco.com/27006bce-b3a7-4ffc-bad6-de257c0be7b8/hattoncg.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672508902/Frame%20Profile%20Images/Hatton/hatton-30-cg_paawwe.jpg',
        width: {
          in: 1.18,
          mm: 30
        },
        depth: {
          in: 1.18,
          mm: 30
        },
        rebateh: {
          in: 0.59,
          mm: 15
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 76,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 196.85,
          mm: 5000
        }
      },
      {
        option1: '20mm(0.79in)',
        option2: 'Silver',
        sku: 'W9456550',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1673327155/Frame%20Patterns/W9456550-hatton-s_rvshgu.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1673327661/Frame%20Profile%20Images/Hatton/hatton-20-s_urrsjp.jpg',
        width: {
          in: 0.79,
          mm: 20
        },
        depth: {
          in: 0.79,
          mm: 20
        },
        rebateh: {
          in: 0.39,
          mm: 10
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 65,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '30mm(1.18in)',
        option2: 'Silver',
        sku: 'W9457550',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1673327155/Frame%20Patterns/W9456550-hatton-s_rvshgu.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1673327660/Frame%20Profile%20Images/Hatton/hatton-30-s_galdkz.jpg',
        width: {
          in: 1.18,
          mm: 30
        },
        depth: {
          in: 1.18,
          mm: 30
        },
        rebateh: {
          in: 0.59,
          mm: 15
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 76,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 196.85,
          mm: 5000
        }
      }
    ]
  },
  {
    id: 'kingston',
    name: 'Kingston',
    category: 'Premium',
    description: `The Kingston collection is one of our most popular and creates a modern, minimalist look that compliments artwork perfectly. This profile is also avaliable on all our in-house print designs. This frame profile is manufactured to the highest standards in Germany, made of aluminium and avaliable in several frame finishes including real-wood veneers.`,
    type: 'Metal',
    material: 'Aluminium',
    manufactured: 'Germany',
    examples: [
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674748523/Examples/Kingston/kingston-front_q4ns2p.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674748523/Examples/Kingston/kingston-front_q4ns2p.jpg',
        caption: 'Matt Black'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674748523/Examples/Kingston/kingston-corner_vzdmhh.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674748523/Examples/Kingston/kingston-corner_vzdmhh.jpg',
        caption: 'Matt Black'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674749183/Examples/Kingston/kingston-matt_black_jv5eaz.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674749183/Examples/Kingston/kingston-matt_black_jv5eaz.jpg',
        caption: 'Matt Black'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674749184/Examples/Kingston/kingston-matt_silver_no7atx.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674749184/Examples/Kingston/kingston-matt_silver_no7atx.jpg',
        caption: 'Matt Silver'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674749184/Examples/Kingston/kingston-brushed_copper_xkoh1g.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674749184/Examples/Kingston/kingston-brushed_copper_xkoh1g.jpg',
        caption: 'Brushed Copper'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674749184/Examples/Kingston/kingston-brushed_champagne_gold_bq53px.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674749184/Examples/Kingston/kingston-brushed_champagne_gold_bq53px.jpg',
        caption: 'Brushed Champagne Gold'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674749183/Examples/Kingston/kingston-brushed_steel_rllvc2.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674749183/Examples/Kingston/kingston-brushed_steel_rllvc2.jpg',
        caption: 'Brushed Steel'
      },
    ],
    variations: [
      {
        option1: '7.8mm(0.31in)',
        option2: 'Matt Black',
        sku: '180250',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511101/Frame%20Profile%20Images/Kingston/kingston-8-mb_wdk4vh.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Matt Silver',
        sku: '180004',
        pattern: 'https://app.printframeco.com/8cec1c4a-2aee-44ef-a303-dbc835375979/kingstonms.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511101/Frame%20Profile%20Images/Kingston/kingston-8-ms_rc1ink.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Brushed Copper',
        sku: '180221',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674232268/Frame%20Patterns/general-c_u3cv3a.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1672511101/Frame%20Profile%20Images/Kingston/kingston-8-bc_zwvky5.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Champagne Gold',
        sku: '180220',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674234412/Frame%20Patterns/general-cg_eoue8f.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1674236596/Frame%20Profile%20Images/Kingston/kingston-8-cg_b1y4cz.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Brushed Steel',
        sku: '180225',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674747078/Frame%20Patterns/general-bs_tdkik1.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672511101/Frame%20Profile%20Images/Kingston/kingston-8-bs_zqodhj.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Dark Grey Gloss',
        sku: '180020',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674744185/Frame%20Patterns/general-gdg_q5ketg.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672511101/Frame%20Profile%20Images/Kingston/kingston-8-gdg_jcvhpw.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Black Oak',
        sku: '181526',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674246175/Frame%20Patterns/general-bo_vkwcve.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1672511102/Frame%20Profile%20Images/Kingston/kingston-8-bo_rdcxlr.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Oak',
        sku: '181514',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674871523/Frame%20Patterns/general-o_ffg7zk.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672511102/Frame%20Profile%20Images/Kingston/kingston-8-o_ob1gie.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'White Oak',
        sku: '181525',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674871646/Frame%20Patterns/general-wo_r0t1ce.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672511102/Frame%20Profile%20Images/Kingston/kingston-8-wo_pbnlop.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '7.8mm(0.31in)',
        option2: 'Wenge',
        sku: '181515',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1674871704/Frame%20Patterns/general-wenge_thlk9q.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1672511102/Frame%20Profile%20Images/Kingston/kingston-8-w_sm775x.jpg',
        width: {
          in: 0.31,
          mm: 7.8
        },
        depth: {
          in: 1.02,
          mm: 25.9
        },
        rebateh: {
          in: 0.38,
          mm: 9.7
        },
        rebate: {
          in: 0.23,
          mm: 5.8
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
    ]
  },
  {
    id: 'hackney',
    name: 'Hackney',
    category: 'Standard',
    description: `Our Hackney collection has been developed to create a minimalist and simple frame profile range that works with a most types of artwork as well as an offering of several face widths.`,
    type: 'Wood',
    material: 'Ayous',
    manufactured: 'Italy',
    examples: [
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1676316546/Examples/Hackney/hackney-front_qyq6na.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1676316546/Examples/Hackney/hackney-front_qyq6na.jpg',
        caption: 'Hackney / Black'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1676316685/Examples/Hackney/hackney-corner_ngyjse.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1676316685/Examples/Hackney/hackney-corner_ngyjse.jpg',
        caption: 'Hackney / Black'
      },
    ],
    variations: [
      //Black
      {
        option1: '15mm(0.59in)',
        option2: 'Black',
        sku: 'W92141440',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-15-b_qipjoq.jpg',
        width: {
          in: 0.59,
          mm: 15
        },
        depth: {
          in: 0.79,
          mm: 20
        },
        rebateh: {
          in: 0.59,
          mm: 15
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 30,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 56.46,
          mm: 1434
        }
      },
      {
        option1: '20mm(0.79in)',
        option2: 'Black',
        sku: 'W93020131',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-20-b_wvcwpc.jpg',
        width: {
          in: 0.79,
          mm: 20
        },
        depth: {
          in: 0.51,
          mm: 13
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 35,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 79.84,
          mm: 2028
        }
      },
      {
        option1: '30mm(1.18in)',
        option2: 'Black',
        sku: 'W93030131',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-20-b_wvcwpc.jpg',
        width: {
          in: 1.18,
          mm: 30
        },
        depth: {
          in: 0.51,
          mm: 13
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 79.84,
          mm: 2028
        }
      },
      {
        option1: '40mm(1.57in)',
        option2: 'Black',
        sku: 'W93040131',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-20-b_wvcwpc.jpg',
        width: {
          in: 1.57,
          mm: 40
        },
        depth: {
          in: 0.55,
          mm: 14
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 45,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 79.84,
          mm: 2028
        }
      },
      //White
      {
        option1: '15mm(0.59in)',
        option2: 'White',
        sku: 'W92141439',
        pattern: 'https://app.printframeco.com/a63ac96a-3c07-49a7-94d2-5058ea299994/standardw.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-15-w_ljamkq.jpg',
        width: {
          in: 0.59,
          mm: 15
        },
        depth: {
          in: 0.79,
          mm: 20
        },
        rebateh: {
          in: 0.59,
          mm: 15
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 30,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ]
      },
      {
        option1: '20mm(0.79in)',
        option2: 'White',
        sku: 'W93020132',
        pattern: 'https://app.printframeco.com/a63ac96a-3c07-49a7-94d2-5058ea299994/standardw.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-15-w_ljamkq.jpg',
        width: {
          in: 0.79,
          mm: 20
        },
        depth: {
          in: 0.51,
          mm: 13
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 35,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 79.84,
          mm: 2028
        }
      },
      {
        option1: '30mm(1.18in)',
        option2: 'White',
        sku: 'W93030132',
        pattern: 'https://app.printframeco.com/a63ac96a-3c07-49a7-94d2-5058ea299994/standardw.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-15-w_ljamkq.jpg',
        width: {
          in: 1.18,
          mm: 30
        },
        depth: {
          in: 0.51,
          mm: 13
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 40,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 79.84,
          mm: 2028
        }
      },
      {
        option1: '40mm(1.57in)',
        option2: 'White',
        sku: 'W93040132',
        pattern: 'https://app.printframeco.com/a63ac96a-3c07-49a7-94d2-5058ea299994/standardw.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-15-w_ljamkq.jpg',
        width: {
          in: 1.57,
          mm: 40
        },
        depth: {
          in: 0.55,
          mm: 14
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.2,
          mm: 5
        },
        costm: 45,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 79.84,
          mm: 2028
        }
      },
      //***deep
      {
        option1: '20mm(0.79in) Deep',
        option2: 'Black',
        sku: 'W92142040',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-20-b_wvcwpc.jpg',
        width: {
          in: 0.79,
          mm: 20
        },
        depth: {
          in: 1.18,
          mm: 30
        },
        rebateh: {
          in: 0.91,
          mm: 23
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 35,
        compatibility: [
          {
            media: 'object',
            additionalmedia: null,
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 79.84,
          mm: 2028
        }
      },
      {
        option1: '25mm(0.98in)',
        option2: 'Black',
        sku: 'W92152540',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-25-b_o78w7p.jpg',
        width: {
          in: 0.98,
          mm: 25
        },
        depth: {
          in: 1.38,
          mm: 35
        },
        rebateh: {
          in: 1.06,
          mm: 27
        },
        rebate: {
          in: 0.31,
          mm: 8
        },
        costm: 60,
        compatibility: [
          {
            media: 'object',
            additionalmedia: null,
            additionalmediatype: null
          }
        ]
      },
      {
        option1: '40mm(1.57in)',
        option2: 'Black',
        sku: 'W99746016',
        pattern: 'https://app.printframeco.com/ad26b6be-b15b-4729-92a8-0238d5d6fcb0/kingstonmb.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1672511133/Frame%20Profile%20Images/Hackney/hackney-40-b_i6ptoi.jpg',
        width: {
          in: 1.57,
          mm: 40
        },
        depth: {
          in: 1.57,
          mm: 40
        },
        rebateh: {
          in: 1.02,
          mm: 26
        },
        rebate: {
          in: 0.39,
          mm: 10
        },
        costm: 70,
        compatibility: [
          {
            media: 'object',
            additionalmedia: null,
            additionalmediatype: null
          }
        ]
      },
      {
        option1: '20mm(0.79in)',
        option2: 'White',
        sku: 'W92142039',
        pattern: 'https://app.printframeco.com/a63ac96a-3c07-49a7-94d2-5058ea299994/standardw.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-20-w_nbngqm.jpg',
        width: {
          in: 0.79,
          mm: 20
        },
        depth: {
          in: 1.18,
          mm: 30
        },
        rebateh: {
          in: 0.91,
          mm: 23
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 50,
        compatibility: [
          {
            media: 'object',
            additionalmedia: null,
            additionalmediatype: null
          }
        ]
      },
      {
        option1: '25mm(0.98in)',
        option2: 'White',
        sku: 'W92152539',
        pattern: 'https://app.printframeco.com/a63ac96a-3c07-49a7-94d2-5058ea299994/standardw.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511132/Frame%20Profile%20Images/Hackney/hackney-25-w_i7jpfp.jpg',
        width: {
          in: 0.98,
          mm: 25
        },
        depth: {
          in: 1.38,
          mm: 35
        },
        rebateh: {
          in: 1.06,
          mm: 27
        },
        rebate: {
          in: 0.31,
          mm: 8
        },
        costm: 60,
        compatibility: [
          {
            media: 'object',
            additionalmedia: null,
            additionalmediatype: null
          }
        ]
      },
      {
        option1: '40mm(1.57in)',
        option2: 'White',
        sku: 'W99746010',
        pattern: 'https://app.printframeco.com/a63ac96a-3c07-49a7-94d2-5058ea299994/standardw.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200,g_face/v1672511133/Frame%20Profile%20Images/Hackney/hackney-40-w_fbassj.jpg',
        width: {
          in: 1.57,
          mm: 40
        },
        depth: {
          in: 1.57,
          mm: 40
        },
        rebateh: {
          in: 1.02,
          mm: 26
        },
        rebate: {
          in: 0.39,
          mm: 10
        },
        costm: 70,
        compatibility: [
          {
            media: 'object',
            additionalmedia: null,
            additionalmediatype: null
          }
        ]
      },
    ]
  },
  {
    id: 'vauxhall',
    name: 'Vauxhall',
    category: 'Luxury',
    description: `Open grain painted finish with metallic foiled stepped inner edge.`,
    type: 'Wood',
    material: 'Ayous',
    manufactured: 'Italy',
    examples: [
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675052498/Examples/Vauxhall/vauxhall-front_ooufiz.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675052498/Examples/Vauxhall/vauxhall-front_ooufiz.jpg',
        caption: 'Black/Gold'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675052498/Examples/Vauxhall/vauxhall-corner_ebep1f.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675052498/Examples/Vauxhall/vauxhall-corner_ebep1f.jpg',
        caption: 'Black/Gold'
      }
    ],
    variations: [
      {
        option1: '33mm(1.3in)',
        option2: 'Black/Gold',
        sku: 'CL3288',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675020073/Frame%20Patterns/vauxhall-bg_r5j2qz.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675052061/Frame%20Profile%20Images/Vauxhall/vauxhall-33-bg_ssuryr.jpg',
        width: {
          in: 1.3,
          mm: 33
        },
        depth: {
          in: 0.98,
          mm: 25
        },
        rebateh: {
          in: 0.39,
          mm: 10
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 65,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '52mm(2.05in)',
        option2: 'Black/Gold',
        sku: 'CL3291',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675020073/Frame%20Patterns/vauxhall-bg_r5j2qz.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675052061/Frame%20Profile%20Images/Vauxhall/vauxhall-52-bg_joeqml.jpg',
        width: {
          in: 2.05,
          mm: 52
        },
        depth: {
          in: 1.22,
          mm: 31
        },
        rebateh: {
          in: 0.43,
          mm: 11
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 75,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '68mm(2.68in)',
        option2: 'Black/Gold',
        sku: 'CL3294',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675020073/Frame%20Patterns/vauxhall-bg_r5j2qz.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675052061/Frame%20Profile%20Images/Vauxhall/vauxhall-68-bg_fxkrey.jpg',
        width: {
          in: 2.68,
          mm: 68
        },
        depth: {
          in: 1.22,
          mm: 31
        },
        rebateh: {
          in: 0.43,
          mm: 11
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 85,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
    ]
  },
  {
    id: 'mayfair',
    name: 'Mayfair',
    category: 'Luxury',
    description: `Our Mayfair profile has been designed to create an impact in any room with it's elegant smooth curves and lightly hand painted finish leaving a subtle wood grain trim. Available in 3 different face widths and 3 different colours.`,
    type: 'Wood',
    material: 'Pine',
    manufactured: 'Italy',
    examples: [
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675432026/Examples/Mayfair/mayfair-multiple_rkkd3k.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675432026/Examples/Mayfair/mayfair-multiple_rkkd3k.jpg',
        caption: 'Black, White & Brown all sizes'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1676316902/Examples/Mayfair/mayfair-front_sax56c.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1676316902/Examples/Mayfair/mayfair-front_sax56c.jpg',
        caption: 'Black / 61mm'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1676316904/Examples/Mayfair/mayfair-corner_qvy9by.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1676316904/Examples/Mayfair/mayfair-corner_qvy9by.jpg',
        caption: 'Black / 61mm'
      },
      {
        thumbnail: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1676316972/Examples/Mayfair/mayfair-angle_j6z0yc.jpg',
        fullsize: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1676316972/Examples/Mayfair/mayfair-angle_j6z0yc.jpg',
        caption: 'Black / 61mm'
      },
    ],
    variations: [
      {
        option1: '26mm(1.02in)',
        option2: 'Black',
        sku: 'W307238',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675190448/Frame%20Patterns/mayfair-black_x5thok.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-26-black_z6w0em.jpg',
        width: {
          in: 1.02,
          mm: 26
        },
        depth: {
          in: 0.83,
          mm: 21
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 80,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '26mm(1.02in)',
        option2: 'Brown',
        sku: 'W307237',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675191245/Frame%20Patterns/mayfair-brown_m7utsq.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189331/Frame%20Profile%20Images/Mayfair/mayfair-26-brown_tn3m0l.jpg',
        width: {
          in: 1.02,
          mm: 26
        },
        depth: {
          in: 0.83,
          mm: 21
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 80,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '26mm(1.02in)',
        option2: 'White',
        sku: 'W307239',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675189921/Frame%20Patterns/mayfair-white_gzzdvr.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-26-white_qh5ohf.jpg',
        width: {
          in: 1.02,
          mm: 26
        },
        depth: {
          in: 0.83,
          mm: 21
        },
        rebateh: {
          in: 0.35,
          mm: 9
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 80,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '39mm(1.54in)',
        option2: 'Black',
        sku: 'W306238',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675190448/Frame%20Patterns/mayfair-black_x5thok.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-39-black_hh78tq.jpg',
        width: {
          in: 1.54,
          mm: 39
        },
        depth: {
          in: 1.06,
          mm: 27
        },
        rebateh: {
          in: 0.51,
          mm: 13
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 100,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '39mm(1.54in)',
        option2: 'White',
        sku: 'W306239',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675189921/Frame%20Patterns/mayfair-white_gzzdvr.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-39-white_phlrk2.jpg',
        width: {
          in: 1.54,
          mm: 39
        },
        depth: {
          in: 1.06,
          mm: 27
        },
        rebateh: {
          in: 0.51,
          mm: 13
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 100,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '39mm(1.54in)',
        option2: 'Brown',
        sku: 'W306237',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675191245/Frame%20Patterns/mayfair-brown_m7utsq.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-39-brown_qtucrc.jpg',
        width: {
          in: 1.54,
          mm: 39
        },
        depth: {
          in: 1.06,
          mm: 27
        },
        rebateh: {
          in: 0.51,
          mm: 13
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 100,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '61mm(2.4in)',
        option2: 'Black',
        sku: 'W305238',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675190448/Frame%20Patterns/mayfair-black_x5thok.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-39-black_hh78tq.jpg',
        width: {
          in: 2.4,
          mm: 61
        },
        depth: {
          in: 1.57,
          mm: 40
        },
        rebateh: {
          in: 0.47,
          mm: 12
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 120,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '61mm(2.4in)',
        option2: 'White',
        sku: 'W305239',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675189921/Frame%20Patterns/mayfair-white_gzzdvr.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-61-white_ezv6mj.jpg',
        width: {
          in: 2.4,
          mm: 61
        },
        depth: {
          in: 1.57,
          mm: 40
        },
        rebateh: {
          in: 0.47,
          mm: 12
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 120,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
      {
        option1: '61mm(2.4in)',
        option2: 'Brown',
        sku: 'W305237',
        pattern: 'https://res.cloudinary.com/dmoqthczr/image/upload/v1675191245/Frame%20Patterns/mayfair-brown_m7utsq.jpg',
        profile: 'https://res.cloudinary.com/dmoqthczr/image/upload/c_thumb,w_200/v1675189330/Frame%20Profile%20Images/Mayfair/mayfair-61-brown_um7tin.jpg',
        width: {
          in: 2.4,
          mm: 61
        },
        depth: {
          in: 1.57,
          mm: 40
        },
        rebateh: {
          in: 0.47,
          mm: 12
        },
        rebate: {
          in: 0.28,
          mm: 7
        },
        costm: 120,
        compatibility: [
          {
            media: 'digital',
            additionalmedia: null,
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'paper',
            additionalmediatype: null
          },
          {
            media: 'art',
            additionalmedia: 'canvas',
            additionalmediatype: 'canvassheet'
          },
          {
            media: 'map',
            additionalmedia: 'paper',
            additionalmediatype: null
          }
        ],
        maxsize: {
          in: 157.48,
          mm: 4000
        }
      },
    ]
  },
];

let windowmounts = [
  {
    id: "white/white",
    name: `White (White Core)`,
    thickness: {
      in: 0.055,
      mm: 1.4
    },
    face: '#FFFFFF',
    core: '#EBEBEB'
  },
  {
    id: "offwhite/white",
    name: `Off White (White Core)`,
    thickness: {
      in: 0.055,
      mm: 1.4
    },
    face: '#F5F5F5',
    core: '#EBEBEB'
  },
  {
    id: "cream/white",
    name: `Cream (White Core)`,
    thickness: {
      in: 0.055,
      mm: 1.4
    },
    face: '#FFFDD0',
    core: '#EBEBEB'
  },
  {
    id: "black/white",
    name: `Black (White Core)`,
    thickness: {
      in: 0.055,
      mm: 1.4
    },
    face: '#000000',
    core: '#EBEBEB'
  },
]